import { Tabs as KitTabs } from '@cinesend/ui-kit'
import { useLocation, useNavigate } from 'react-router-dom'

const tabValue = (tab, index) => String(tab.to || tab.name || index)

const Tabs = ({ list = [], className = 'mb-8', label = 'Sections' }) => {
  const navigate = useNavigate()
  const pathname = useLocation().pathname
  const visible = list.filter((tab) => tab.visible ?? true)
  if (visible.length === 0) return null

  const matches = (tab) => {
    if (tab.selected) return true
    if (!tab.to) return false
    if (String(tab.to).startsWith('/')) return pathname === tab.to
    return pathname.split('/').includes(String(tab.to))
  }

  const active = visible.find(matches) ?? visible[0]

  return (
    <KitTabs
      label={label}
      className={className}
      value={tabValue(active, visible.indexOf(active))}
      options={visible.map((tab, index) => ({
        value: tabValue(tab, index),
        label: String(tab.name ?? '').replaceAll('-', ' '),
      }))}
      onValueChange={(value) => {
        const tab = visible.find((item, index) => tabValue(item, index) === value)
        if (!tab) return
        if (typeof tab.onClick === 'function') tab.onClick()
        else if (tab.to) navigate(tab.to)
      }}
    />
  )
}

export default Tabs
